import { useState } from 'react'
import Icon from '@/components/icon'
import { copyHtmlToClipBoard, cx } from '@/utils/strings'
import { useTranslations } from '@/utils/locale'
import DOMPurify from 'isomorphic-dompurify'

export interface Props {
  id?: string
  text?: string
  theme?: 'dark' | 'light'
  language?: string
  className?: string
}

export default function CopyButton({ id, text, theme = 'dark', className }: Props) {
  const [copied, setCopied] = useState(false)
  const { t } = useTranslations()

  const handleCopy = () => {
    if (text) {
      navigator.clipboard.writeText(text)
    } else if (id) {
      const content = document.getElementById(id)?.innerHTML || ''
      copyHtmlToClipBoard(DOMPurify.sanitize(content))
    }
    setCopied(true)
    setTimeout(() => setCopied(false), 3000)
  }

  if (!text && !id) return null
  return (
    <button
      type="button"
      className={cx('flex items-center justify-center opacity-80 hover:opacity-100 transition-opacity', className)}
      title={t('Copy Text')}
      aria-label={t('Copy Text')}
      onClick={handleCopy}
      onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => e.key === 'Enter' && handleCopy()}
    >
      <span className="mr-2">{copied ? t('Copied!') : t('Copy')}</span>
      <span className="text-base bwi bwi-copy" />
    </button>
  )
}
